
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Mask Group 3","transform":"translate(-9087.066 289.883)","clip-path":"url(#clip-path)"}},[_c('g',{attrs:{"transform":"translate(9087.066 -289.883)"}},[_c('circle',{attrs:{"data-name":"Ellipse 1534","cx":"30","cy":"30","r":"30","fill":"#7469d9"}}),_c('path',{attrs:{"data-name":"Path 1693","d":"M60 30q0-.746-.037-1.484S60 46.569 60 30z","fill":"#3a6da1"}}),_c('g',{attrs:{"data-name":"Group 2672","fill":"#fff"}},[_c('path',{attrs:{"data-name":"Path 1694","d":"M10.338 18.338v23.3L21.7 29.941z"}}),_c('path',{attrs:{"data-name":"Path 1695","d":"M49.662 18.338v23.3l-11.306-11.65z"}}),_c('path',{attrs:{"data-name":"Path 1696","d":"M11.2 17.281h37.53L33.978 32.64a5.567 5.567 0 01-8.03 0z"}}),_c('path',{attrs:{"data-name":"Path 1697","d":"M34.829 33.457a6.746 6.746 0 01-9.732 0l-2.5-2.605L11.2 42.719h37.53l-11.4-11.867z"}})])])])])
          )
        }
      }
    